// extracted by mini-css-extract-plugin
module.exports = {"container":"TableBody_container__c6Sd3","subrow":"TableBody_subrow__D07CT"};